export const slugify = (slug) => {
  if (typeof slug !== "string") return "";
  return slug
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')  // replace spaces and special chars with -
    .replace(/^-+|-+$/g, '');     // remove leading/trailing dashes
};

export const slugToText = (slug) => {
  if (!slug) return "";
  return slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
 